module.exports = {
	Copyright:'Copyright © 2022',
	name:'မိမိအကောင့်',
	settings:'ဆက်တင်',
	Ranking:'အဆင့်သတ်မှတ်ချက်',
	Questions:'မေးခွန်းများ',
	Contents:'အကြောင်းအရာများ',
	myAccount:'မိမိအကောင့်',
	Edit:'ပြင်ဆင်မည်',
	Save:'သိမ်းဆည်းပါ',
	Member_since:'မန်ဘာစတင်ဖြစ်သည့်ရက်',
	Last_login:'နောက်ဆုံးလော့ဂ်အင် ဝင်သည့်ရက်',
	day:'နေ့စဉ်',
	week:'အပတ်စဉ်',
	Login:'ဝင်ရောက်မယ်',
  OTP:'တစ်ခါသုံးပတ်စ်ဝက်',
  Get:'ရယူပါ',
  RESEND:'ပြန်လည်ပေးပို့မယ်',
  codeTips1:'ကျေးဇူးပြု၍  သင့်ဖုန်းနံပါတ်ကို ထည့်သွင်းပါ။',
  codeTips2:'တစ်ခါသုံးပတ်စ်ဝက် (OTP) ကို သင့်ဖုန်းသို့ ပို့ပေးလိုက်ပါပြီ။ ကျေးဇူးပြု၍ စစ်ဆေးပြီး ထည့်သွင်းပါ။',
  codeTips3:'ကျေးဇူးပြု၍ မှန်ကန်သော တစ်ခါသုံးပတ်စ်ဝက်ကို ဖြည့်သွင်းပါ',
  loginCode:'ဝင်ရောက်မယ်',
	phone_number:'သင်၏ဖုန်းနံပါတ်ကိုထည့်ပါ',
	My_score:'မိမိအမှတ်',
	FAQs:'မေးလေ့မေးထရှိသော မေးခွန်းများ',
	T_C:'စည်းကမ်းသတ်မှတ်ချက်များ',
	T_C2:'စည်းကမ်းသတ်မှတ်ချက်များ',
	Privacy_Policy:'ကိုယ်ရေးအချက်အလက်မူဝါဒ',
	Unsubscribe:'စာရင်းသွင်းခြင်းမှ ဖြုတ်မည်',
	Terms_of_Use:'Study Go ၏ စည်းကမ်းသတ်မှတ်ချက်များ',
	no_data:'အချက်အလက်မရှိပါ',
	Ranking_Score:'အဆင့်သတ်မှတ်ချက်ရမှတ်',
	Today:'ဒီနေ့',
  Week_Rank:'အပတ်စဉ်',
	Monthly:'လစဉ်',
	Question_List:'မေးခွန်းစာရင်း',
	Question_ID:'မေးခွန်းအိုင်ဒီ',
	Question_Status:'မေးခွန်းအခြေအနေ',
	Questions_are_answered:'မေးခွန်းများအား ဖြေဆိုလို့ ပြီးပါပြီ',
	Questions_are_not_answered:'မေးခွန်းများအား မဖြေဆိုရသေးပါ',
	Continue:'ဆက်ရန်',
	Get_more_questions:'နောက်ထပ်မေးခွန်းများ ရယူရန်',
	Next:'နောက်သို့',
	Submit:'စာလွှတ်ပါ',
	Your_correct_answer_number_is:'သင့်အတွက် အဖြေမှန်နံပါတ်မှာ',
	Your_total_score_is:'သင်၏ စုစုပေါင်း ရလဒ်မှာ',
	Review:'သုံးသပ်မည်',
	cancel:'ပယ်ဖျက်ပါ',
	Confirm:'အတည်ပြုမည်',
	No:'မသေချာသေးပါ',
	OK:'သေချာပါပြီ',
	Yes:'သေချာပါပြီ',
	No_Question:'မေးခွန်းမရှိတော့ပါ',
	Back:'နောက်သို့',
	Content_List:'အကြောင်းအရာစာရင်း',
	Read_more:'ဆက်ဖတ်ရန်',
	more:'ထပ်မံကြည့်ရှုရန်',
	noMore:'No more',
	des:'စာရင်းသွင်းခြင်းမှ ဖြုတ်တော့မည်မှာ သေချာပြီလား?',
	des2:'ရှင်တို့ကို လက်မှတ်ပေးချင်လား။',
	tips:'သင့်ဖုန်းနံပါတ်ကို ထည့်သွင်းပါ',
	tips2:'လုပ်ဆောင်မှု မအောင်မြင်ပါ',
	msg2:'သင်ဟာ ဉာဏ်စမ်းမေးခွန်းတစ်စုံကို ဝယ်ယူတော့မှာ ဖြစ်ပါတယ်။ အဆိုပါတစ်စုံအတွက် 149 ကျပ် ကျသင့်မှာ ဖြစ်ပါတယ်။',
	msg1:'သင်သည် မေးခွန်းများကို ဖြေဆိုလို့ ပြီးဆုံးပါပြီ။ ထပ်မံဖြေဆိုရန်အတွက် ကျေးဇူးပြု၍ ဝယ်ယူပါ သို့မဟုတ် မနက်ဖြန်အထိ စောင့်ဆိုင်းပေးပါ။',
	loading:'loading',
	loadMore:'ထပ်မံကြည့်ရှုရန် အောက်သို့ ဆွဲချပါ',
	loadMore2:"နောက်ထပ် မရှိတော့ပါ",
}



// WEBPACK FOOTER //
// ./src/assets/i18n/my.js